import React, { useEffect } from "react";

const QrDownload = () => {
  const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.ta.wallet.tawallet&hl=en_IN";

  const APP_STORE_URL =
    "https://apps.apple.com/in/app/ta-wallet/id1381087275";

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.location.replace(PLAY_STORE_URL);
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.replace(APP_STORE_URL);
    }
  }, []);

  const s = {
    wrapper: {
      height: "100vh",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // Transaction Analysts Green Gradient
      background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
      fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      padding: "20px",
      boxSizing: "border-box",
    },
    card: {
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      backdropFilter: "blur(10px)",
      padding: "40px 30px",
      borderRadius: "24px",
      boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
      maxWidth: "450px",
      width: "100%",
      textAlign: "center",
      border: "1px solid #ffffff",
    },
    logoPlaceholder: {
      width: "80px",
      height: "80px",
      backgroundColor: "#34A853", // TA Green
      borderRadius: "18px",
      margin: "0 auto 20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      fontSize: "32px",
      fontWeight: "bold",
      boxShadow: "0 8px 16px rgba(52, 168, 83, 0.2)",
    },
    title: {
      fontSize: "28px",
      color: "#1a202c",
      margin: "0 0 10px 0",
      fontWeight: "700",
    },
    subtitle: {
      fontSize: "16px",
      color: "#4a5568",
      lineHeight: "1.5",
      marginBottom: "30px",
    },
    btnContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "15px",
    },
    googleBtn: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      padding: "16px",
      background: "#34A853", // TA Green
      color: "#fff",
      borderRadius: "14px",
      textDecoration: "none",
      fontWeight: "600",
      fontSize: "17px",
      transition: "transform 0.2s, background 0.2s",
    },
    appleBtn: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      padding: "16px",
      background: "#000000",
      color: "#fff",
      borderRadius: "14px",
      textDecoration: "none",
      fontWeight: "600",
      fontSize: "17px",
      transition: "transform 0.2s",
    }
  };

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        <div style={s.logoPlaceholder}>TA</div>
        
        <h2 style={s.title}>Experience TA Wallet</h2>
        <p style={s.subtitle}>
          Secure transactions at your fingertips. <br/>
          Select your platform to continue.
        </p>

        <div style={s.btnContainer}>
          <a
            href={PLAY_STORE_URL}
            style={s.googleBtn}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#2d9249")}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#34A853")}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
               <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L18.66,16.19C19.16,16.47 19.4,17.02 19.24,17.55C19.08,18.09 18.5,18.42 17.96,18.26L14.85,13.15L16.81,15.12M14.85,10.85L17.96,5.74C18.5,5.58 19.08,5.91 19.24,6.45C19.4,6.98 19.16,7.53 18.66,7.81L16.81,8.88L14.85,10.85M14.03,12L20.16,18.13L14.03,12Z" />
            </svg>
            Google Play
          </a>

          <a
            href={APP_STORE_URL}
            style={s.appleBtn}
            onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
            onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
               <path d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
            </svg>
            App Store
          </a>
        </div>

        <div style={{ marginTop: "30px", fontSize: "12px", color: "#a0aec0" }}>
          © {new Date().getFullYear()} Transaction Analysts. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default QrDownload;